import { styled } from "../stitches";
import Box from "./Box";

const Flex = styled(Box, {
  display: "flex",
});

export default Flex;
